export const imageSizes = {
  screen1: '200x300,400x600',
  screen2: '250x375,500x750',
  screen3: '300x450,600x900',
  screen4: '350x525,700x1050',
  screen5: '500x750,1000x1500',
  screen6: '600x900,1200x1800',
};

export const imageBreakpoints = {
  screen1: '(max-width: 320px)',
  screen2: '(min-width: 321px) and (max-width: 450px)',
  screen3: '(min-width: 451px) and (max-width: 990px)',
  screen4: '(min-width: 991px) and (max-width: 1550px)',
  screen5: '(min-width: 1551px) and (max-width: 1960px)',
  screen6: '(min-width: 1961px)',
};
const initialDpr = 1;

export const viewportMobileRanges = {
  0: [0, 320],
  1: [321, 450],
  2: [451, 990],
  3: [991, 1550],
  4: [1551, 1960],
}

/**
 * Build srcset string for responsive images
 * @param {Object} param - context
 * @param {String} param.image - image url
 * @param {String} param.layout - layout type (mobile or desktop)
 * @param {Boolean} param.setHeight - set height in the url
 * @returns {String} - srcset string
 */
export function buildSrcSet({image, layout, setHeight}) {
  let srcSet = '';

  // If no image provided, return empty string
  if (!image) return '';

  const slots = imageSizes[layout].split(',');
  if (slots.length !== 2) return '';

  let stepDpr = 0;
  slots.forEach((size) => {
    srcSet += `${image}${image.includes('?') ? '&' : '?'}width=${size.split('x')[0]}${setHeight ? `&height=${
      size.split('x')[1]
    }` : ''}&crop=center ${initialDpr + stepDpr}x, `;
    stepDpr += 0.1;
  });

  return srcSet;
}

/**
 * Build a source element for responsive image
 * @param {Object} param - context
 * @param {String} param.image - image url
 * @param {String} param.layout - layout type (mobile or desktop)
 * @param {Boolean} param.setHeight - set height in the url
 * @returns {HTMLSourceElement} - source HTML element
 */
export function buildSource({ image, layout, setHeight }) {
  const source = document.createElement('source');
  source.media = imageBreakpoints[layout];
  source.srcset = buildSrcSet({ image, layout, setHeight });
  return source;
}
